/**
 * Challenges & Gamification API service.
 */
import { apiClient } from "@services/apiClient";

export const challengesApi = {
  getActive: () => apiClient.get("/challenges/active/"),
  getHistory: (days = 7) => apiClient.get("/challenges/history/", { params: { days } }),
  complete: (id: string) => apiClient.post(`/challenges/${id}/complete/`),
  skip: (id: string) => apiClient.post(`/challenges/${id}/skip/`),
  getBadges: () => apiClient.get("/challenges/badges/"),
  getEarnedBadges: () => apiClient.get("/challenges/badges/earned/"),
  getLevel: () => apiClient.get("/challenges/level/"),
  getLeaderboard: () => apiClient.get("/challenges/leaderboard/"),
};

export const highlightsApi = {
  list: (type?: string) => apiClient.get("/highlights/", { params: type ? { type } : {} }),
  getFeatured: () => apiClient.get("/highlights/featured/"),
  get: (id: string) => apiClient.get(`/highlights/${id}/`),
  generate: (type: "ai_weekly" | "ai_monthly" | "mood_based") =>
    apiClient.post("/highlights/generate/", { type }),
  reactToItem: (itemId: string, reaction: string) =>
    apiClient.post(`/highlights/items/${itemId}/react/`, { reaction }),
};

export const journalApi = {
  getEntry: (date: string) => apiClient.get("/journal/", { params: { date } }),
  createOrUpdate: (payload: {
    entry_date: string;
    mood: string;
    mood_score: number;
    secondary_emotions?: string[];
    energy_level?: string;
    gratitude_note?: string;
    reflection?: string;
    tomorrow_intention?: string;
    activities?: string[];
    sleep_quality?: number;
  }) => apiClient.post("/journal/", payload),
  getHistory: (days?: number) =>
    apiClient.get("/journal/history/", { params: days ? { days } : {} }),
  getCalendar: (year: number, month: number) =>
    apiClient.get("/journal/calendar/", { params: { year, month } }),
  getStreak: () => apiClient.get("/journal/streak/"),
  getInsights: (days?: number) =>
    apiClient.get("/journal/insights/", { params: days ? { days } : {} }),
};
